import { gql } from "lib/apolloClient";
import { studentGoalFragments } from "./GoalListFragments";

export const getStudentGoalsQuery = gql`
  query getStudentGoals(
    $studentId: ID!
    $last: Int
    $after: String
    $filters: StudentGoalsFilters
  ) {
    node(id: $studentId, type: STUDENT) {
      id
      ... on Student {
        ...studentGoalsItem
      }
    }
  }
  ${studentGoalFragments.goalFeed}
`;
